import {Permission} from '@/models';
import {Role} from '@/models/opportunities';

export interface PermissionsPolicy {
  [key: string]: Permission[];
}

export interface ModulePermissions extends PermissionsPolicy {
  home: Permission[];
  myAccount: Permission[];
  opportunity: Permission[];
  rules: Permission[];
  geekProfile: Permission[];
  leaderboard: Permission[];
  rewardGeek: Permission[];
  managementPanel: Permission[];
  feedback: Permission[];
  gCoins: Permission[];
  gCoinsWithdrawal: Permission[];
  gCoinsCustomAward: Permission[];
}

export interface OpportunityPermissions extends PermissionsPolicy {
  grantRoles: Permission[];
  addNewOpportunity: Permission[];
  manageOpportunity: Permission[];
  reports: Permission[];
}

export interface RulesPermissions extends PermissionsPolicy {
  activitiesSection: Permission[];
  gCoinsSection: Permission[];
  skillsSection: Permission[];
  opportunitiesSection: Permission[];
  achievementsSection: Permission[];
  badgesSection: Permission[];
  leaderboardSection: Permission[];
  grantingSection: Permission[];
  adminsSection: Permission[];
}

export interface AdminPermissions extends PermissionsPolicy {
  activities: Permission[];
  gCoins: Permission[];
  news: Permission[];
  geeks: Permission[];
  achievements: Permission[];
  seasons: Permission[];
}

export const permissions: ModulePermissions = {
  home: [Permission.General],
  myAccount: [Permission.General],
  opportunity: [Permission.ModuleOpportunity],
  rules: [Permission.General],
  geekProfile: [Permission.General],
  leaderboard: [Permission.Scores],
  rewardGeek: [Permission.ModuleRewardGeek],
  // TODO: Add correct permissions
  managementPanel: [],
  feedback: [Permission.ModuleFeedback],
  gCoins: [Permission.GCoins],
  gCoinsWithdrawal: [Permission.GCoinsWithdrawal],
  gCoinsCustomAward: [Permission.GCoinsCustomAward],
};

export const opportunityPermissions: OpportunityPermissions = {
  grantRoles: [Permission.OpportunityGrantRoles],
  addNewOpportunity: [Permission.OpportunityCreate],
  manageOpportunity: [Permission.OpportunityManage],
  reports: [Permission.OpportunityReports],
};

export const rulesPermissions: RulesPermissions = {
  activitiesSection: [Permission.Activities],
  gCoinsSection: [Permission.GCoins],
  skillsSection: [Permission.Activities, Permission.Scores],
  opportunitiesSection: [Permission.ModuleOpportunity],
  achievementsSection: [Permission.Achievements],
  badgesSection: [Permission.Badges],
  leaderboardSection: [Permission.Scores],
  grantingSection: [Permission.Activities],
  adminsSection: [Permission.General],
};

export const adminPermissions: AdminPermissions = {
  activities: [Permission.ActivitiesManage],
  gCoins: [Permission.GCoinsManage],
  news: [Permission.NewsManage],
  geeks: [Permission.GeeksManage],
  achievements: [Permission.AchievementsManage],
  seasons: [Permission.SeasonsManage],
};

export const opportunityGrantRolePermissions: { [key in Permission]?: Role } = {
  [Permission.OpportunityGrantRoleNone]: Role.None,
  [Permission.OpportunityGrantRoleCandidate]: Role.Candidate,
  [Permission.OpportunityGrantRoleIssuer]: Role.Issuer,
  [Permission.OpportunityGrantRoleApprover]: Role.Approver,
  [Permission.OpportunityGrantRoleAdmin]: Role.Admin,
};
